// extracted by mini-css-extract-plugin
module.exports = {"ButtonPlus":"CardButton_ButtonPlus__25SZe","ButtonMinus":"CardButton_ButtonMinus__13y8t","ButtonFlip":"CardButton_ButtonFlip__1iKnW","flip":"CardButton_flip__2TCis"};